import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// import { useNavigate } from 'react-router-dom';
import * as React from 'react';
// import TextField from '@mui/material/TextField';
// import Autocomplete from '@mui/material/Autocomplete';
// @mui
import { Container, Typography, Stack, Button, IconButton, Card, Box, Modal } from '@mui/material';


// icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddCard from '@mui/icons-material/AddCard';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { UserListToolbar } from '../sections/@dashboard/user';
import Iconify from '../components/iconify';
import AddProposta from './AddProposta';
import ModalDesconto from './ModalDesconto';
import EditPropostaLeads from './Leads/EditProposta/EditPropostaLeads';
// api
import {
  validateUser,
  getUnoProposta,
  updateProposta,
  getChamados,
  updateChamado,
} from './api';
import config from '../config.json';
import PopoverFiltro from './PopoverFiltroChamados';
import ModalLoading from './ModalLoading';


const sxCard = {
  py: 1,
  boxShadow: 0,
  textAlign: 'center',
  backgroundColor: 'azure',
  border: 1,
  minHeight: 50,
  display: 'flex',
  flexDirection: 'column',
  width: 200,
};


// ----------------------------------------------------------------------

export default function Chamados() {
  const [propostas, setPropostas] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalDesconto, setModalDesconto] = useState(false);
  const [dadosDesconto, setDadosDesconto] = useState(null);
  const [rowSelecionado, setRowSelecionado] = useState(null);

  // useEffect(() => { fGetPropostas() }, []);
  const fGetPropostas = (filtro) => {
    getChamados(filtro)
      .then((dados) => {
        setPropostas(dados);
      })
      .catch((error) => {
        // Trate erros aqui
        window.alert('Erro ao consultar banco de dados');
        console.error('Erro ao buscar dados da API:', error);
      });
  };

  // Valida usuario
  const navigate = useNavigate();
  useEffect(() => {
    validateuser();
  }, []);
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {};
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente');
      return;
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario;
  };
  // -------------
  // Outras funcoes e declaracoes
  // ---------------------
  // Modal
  const [open, setOpen] = React.useState(false);
  const [produto, setProduto] = React.useState(null);
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  const [openLead, setOpenLead] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    setOpenLead(false);
    setProduto(null);
  };

  const onConfirmHandler = async (proposta, anexo) => {
    setModalLoading(true);
    try {
      const [result1, result2] = await Promise.all([
        updateProposta(proposta, anexo),
        // updateAnexo(anexo,proposta),
      ]);
      setProduto(null);
      handleClose();
      fGetPropostas(filtro);
    } catch (error) {
      console.error('Erro ao atualizar as coleções:', error);
      // Lidar com erros, se necessário
    }
    setModalLoading(false);
  };

  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  const emptyFiltro = {
    usuarioLogado,
    datainicial: primeiroDiaDoMes,
    datafinal: ultimoDiaDoMes,
  };
  const [filtro, setFiltro] = useState({ ...emptyFiltro });
  const [openFiltro, setOpenFiltro] = useState(null);

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const limparFiltro = () => {
    setFiltro({ ...emptyFiltro });
    setOpenFiltro(null);
  };

  const onConfirmFiltro = (filtroPopover) => {
    setFiltro(filtroPopover);
    setOpenFiltro(null);
  };

  useEffect(() => {
    fGetPropostas(filtro);
  }, [filtro]);
  // Filtro ----

  const handleResponder = async (row) => {
    setRowSelecionado(row);
    setDadosDesconto(row.dados);
    setModalDesconto(true);
  };

  const handleAprovar = async (desconto) => {
    const proposta = await getUnoProposta({ _id: rowSelecionado.pid });
    const newArray = [...proposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `Aprovado desconto - Valor Solicitado: ${desconto.valorsolicitado}, Forma de Pagamento: ${desconto.formapagamento.nome} OBS.: ${desconto.obs}`,
    });

    const newProposta = {
      _id: rowSelecionado.pid,
      desconto: 0,
      acrescimo: 0,
      formapagamento: { ...desconto.formapagamento, obs: desconto.obs },
      valor: desconto.valorsolicitado,
      chamado: true,
      atividades: newArray,
    };
    await updateProposta(newProposta);
    const chamado = { _id: rowSelecionado._id, aberto: false, status: 'Aprovado', userliberacao: usuarioLogado, dataliberacao: new Date() };
    await updateChamado(chamado);

    fechaModal();
  };

  const handleRejeitar = async () => {
    const chamado = { _id: rowSelecionado._id, aberto: false, status: 'Rejeitado', userliberacao: usuarioLogado, dataliberacao: new Date() };
    await updateChamado(chamado);
    fechaModal();
  };

  const fechaModal = () => {
    setRowSelecionado(null);
    setDadosDesconto(null);
    setModalDesconto(false);
    fGetPropostas(filtro);
  };

  const handleVisualiza2 = async () => {
    const proposta = await getUnoProposta({ _id: rowSelecionado.pid });
    if (proposta) {
      const rowCopy = JSON.parse(JSON.stringify(proposta));
      setProduto(rowCopy);
      setOpen(true);
    } else {
      alert('Proposta não encontrada');
    }
  };

  const handleVisualiza = async (row) => {
    const proposta = await getUnoProposta({ _id: row.pid });
    if (proposta) {
      const chamado = { _id: row._id, aberto: true };
      await updateChamado(chamado);
      fGetPropostas(filtro);
      const rowCopy = JSON.parse(JSON.stringify(proposta));
      setProduto(rowCopy);
      if (rowCopy.fluxo.id === 10) {
        setOpenLead(true)
        return;
      }

      setOpen(true);
    } else {
      alert('Proposta não encontrada');
    }
  };

  // ----------------------

  return (
    <>
      <Helmet>
        <title> Chamados </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            Chamados
          </Typography>

          <Button
            onClick={(e) => setOpenFiltro(e.currentTarget)}
            variant="contained"
            startIcon={<Iconify icon="eva:search-fill" />}
            sx={{
              height: 50,
              minWidth: 100,
              backgroundColor: 'MediumSeaGreen',
              marginLeft: 'auto',
              '&:hover': { backgroundColor: 'SeaGreen' },
            }}
          >
            Filtros
          </Button>
        </Stack>

        {/* ------------ Tabela ------------ */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Data</TableCell>
                <TableCell align="left">Solicitante</TableCell>
                <TableCell align="left">Destino</TableCell>
                <TableCell align="left">Nome do Cliente</TableCell>
                <TableCell align="left">Solicitação</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="center">Ação</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {propostas.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },

                    ...(!row.aberto && usuarioLogado._id === row.userdestino._id && {
                      backgroundColor: 'Khaki',
                    }),
                  }}
                >
                  <TableCell align="center">{new Date(row.data).toLocaleDateString()}</TableCell>
                  <TableCell align="left">{row.userabertura?.nome}</TableCell>
                  <TableCell align="left">{row.userdestino?.nome}</TableCell>
                  <TableCell align="left">{row.nomecliente}</TableCell>
                  <TableCell align="left">
                    {(row.tipo === 1 && 'Aplicação de Desconto') || (row.tipo === 2 && 'Orçamento Alocado') || (row.tipo === 3 && 'Agendamento')}
                  </TableCell>
                  <TableCell align="center">{row.tipo === 1 && row.status}</TableCell>
                  <TableCell align="center">
                    {row.tipo === 1 && usuarioLogado.supervisor && row.status === 'Pendente' ? (
                      <Button
                        size="small"
                        variant="contained"
                        color="lightgreen"
                        startIcon={<AddCard />}
                        onClick={() => handleResponder(row)}
                      >
                        Responder
                      </Button>
                    ) : (
                      <Button
                        size="small"
                        variant="contained"
                        startIcon={<VisibilityIcon />}
                        onClick={() => handleVisualiza(row)}
                      >
                        Visualizar
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell align="left" colSpan={3}>
                  <strong>
                    Total: <strong>{propostas.length}</strong>
                  </strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      {openFiltro ? (
        <PopoverFiltro
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
        />
      ) : null}
      {/* Modal Loading */}
      {modalLoading && <ModalLoading open={modalLoading} />}
      {open && <AddProposta open={open} proposta={produto} onClose={handleClose} onConfirm={onConfirmHandler} />}
      {/* Modal Desconto */}
      {modalDesconto && (
        <ModalDesconto
          open={modalDesconto}
          desconto={dadosDesconto}
          onClose={() => setModalDesconto(false)}
          onConfirm={handleAprovar}
          onRejeitar={handleRejeitar}
          onVisualiza={handleVisualiza2}
          responder
        />
      )}
      {
        openLead &&
        <Modal
          open={openLead}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <EditPropostaLeads open={openLead} visualiza onClose={handleClose} proposta={produto} />
        </Modal>
      }
    </>
  );
}
